import {Text} from 'platform/foundation';

export function parseInlineMarkdown(text: string) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);

  return parts.map((part, i) => {
    const key = `${i}:${part}`;

    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <Text key={key} size="xSmall" alternative inline>
          {part.slice(2, -2)}
        </Text>
      );
    }

    return (
      <Text key={key} size="xSmall" inline>
        {part}
      </Text>
    );
  });
}
